import { DEFAULT_INPUT_INDICATOR_LABELS } from "../indicator/labels.js";
import { clamp } from "@videojs/utils/number";
//#region src/core/ui/volume-indicator/status.ts
function isVolumeIndicatorAction(action) {
	return action === "toggleMuted" || action === "volumeStep";
}
function getVolumeLevel(volume) {
	if (volume <= 0) return "off";
	return volume <= .5 ? "low" : "high";
}
function formatVolumeValue(volume) {
	return `${Math.round(clamp(volume, 0, 1) * 100)}%`;
}
function getVolumeIndicatorDisplayValue(state) {
	return state.value ?? "";
}
/** Predicted mute/volume after a volume-indicator action. */
function predictVolumeActionOutcome(event, snapshot) {
	const muted = snapshot.muted === true;
	const snapshotVolume = snapshot.volume ?? 0;
	if (event.action === "toggleMuted") return {
		snapshotVolume,
		nextMuted: !muted,
		nextVolume: snapshotVolume
	};
	if (event.action === "volumeStep") {
		const nextVolume = clamp(snapshotVolume + (event.value ?? 0), 0, 1);
		return {
			snapshotVolume,
			nextMuted: muted && nextVolume <= 0,
			nextVolume
		};
	}
	return {
		snapshotVolume,
		nextMuted: muted,
		nextVolume: snapshotVolume
	};
}
/** Labels/value/level for volume actions, shared with `StatusIndicatorCore`. */
function deriveVolumeStatus(event, snapshot, labels = DEFAULT_INPUT_INDICATOR_LABELS, cachedPrediction) {
	const prediction = cachedPrediction ?? predictVolumeActionOutcome(event, snapshot);
	const level = prediction.nextMuted ? "off" : getVolumeLevel(prediction.nextVolume);
	const value = prediction.nextMuted ? "0%" : formatVolumeValue(prediction.nextVolume);
	return {
		status: level === "off" ? "volume-off" : level === "low" ? "volume-low" : "volume-high",
		label: level === "off" ? labels.muted : labels.volume,
		value,
		volumeLevel: level
	};
}
//#endregion
export { deriveVolumeStatus, formatVolumeValue, getVolumeIndicatorDisplayValue, getVolumeLevel, isVolumeIndicatorAction, predictVolumeActionOutcome };

//# sourceMappingURL=status.js.map